// @ts-ignore
import { VerticalsBridge } from "@osiris/verticals-bridge";
import { useAuth } from "~/store/auth";
import { useSettings } from "~/store/settings";

export default defineNuxtPlugin(() => {
	const auth = useAuth();
	const bridge = new VerticalsBridge({
		windowSetup: {
			authenticate: () => {
				const settings = useSettings();
				if (settings.isNativeApp) return window.promptLogin();
				auth.modals.login = true;
			},
			register: () => (auth.modals.register = true),
			showBalances: () => {},
			refreshBalances: () => {},
			deposit: () => {},
			home: () => {},
			headless: () => {},
			redirect: () => {},
			resize: () => {},
		},
	});
	return {
		provide: {
			verticalBridge: bridge,
		},
	};
});
